import 'slick-carousel/slick/slick'

export default class TestimonialsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-testimonials-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                infinite: true,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                prevArrow: $('.js-testimonials-slider-previous'),
                nextArrow: $('.js-testimonials-slider-next'),
                appendDots: $('.js-testimonials-slider-dots'),
            });

            // snippet to add active class on load - removes when we use appendDots - snippet taken from here - https://stackoverflow.com/questions/69316132/slick-carousel-appenddots-inside-a-slide-loses-active-class

            let activeClass = 'slick-active',
                ariaAttribute = 'aria-hidden';
            
            this.settings.$slider
            .on('init', function(event, slick) {
                let $firstDot = $('.slick-dots li:first-of-type');
                $firstDot.addClass(activeClass).attr(ariaAttribute, false);
            })
            .on('afterChange', function(event, slick, currentSlide) {
                let $dots = $('.slick-dots');
                $('li', $dots).removeClass(activeClass).attr(ariaAttribute, true);
                $dots.each(function() {
                    $('li', $(this)).eq(currentSlide).addClass(activeClass).attr(ariaAttribute, false);
                });
            });

            this.settings.$slider.trigger('init');
        }
    }

};

new TestimonialsSlider();